import { getCustomerType } from "../../selectors";

export const loadPaymentTypes = (customerEmail) => {
  return (dispatch, getState, { api }) => {
    const { cart } = getState();
    const countryCode = cart.countryCodeFromForm;

    const customerType = getCustomerType(getState());

    return api
      .getPaymentTypes(countryCode, customerType.toUpperCase(), customerEmail)
      .then(
        (data) => ({
          wasSuccessful: true,
          data: {
            ...data,
            // Filter out Bank payment option to encourage customers
            // to use recurring payment methods instead.
            paymentTypes:
              data.paymentTypes &&
              data.paymentTypes.filter(({ name }) => name !== "homebanking"),
          },
        }),
        (err) => ({ wasSuccessful: false }),
      );
  };
};
